import { jsx } from "react/jsx-runtime";
import SvgArrowDown from "../../../images/icons/24/Arrow/ArrowDown.svg.js";
import { forwardRef } from "react";
const ArrowDownIcon = forwardRef(({ size, ...props }, ref) => /* @__PURE__ */ jsx(
  SvgArrowDown,
  {
    ref,
    ...size ? { width: size, height: size } : {},
    ...props
  }
));
export {
  ArrowDownIcon,
  ArrowDownIcon as default
};
//# sourceMappingURL=ArrowDown.js.map
